/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import { TFunction } from 'i18next';
import { Box } from '@mantine/core';

import { CreditOptionsResponse } from 'types';
import CreditRequestIncomeItem from './item';

interface CreditRequestIncomeProps {
  disabled?: boolean;
  form: any;
  options: CreditOptionsResponse;
  partnerIncomeForm: any;
  t: TFunction;
  userIncomeForm: any;
  tempIncomeObject: object;
  partner: boolean;
}

const CreditRequestIncome = ({
  disabled,
  form,
  options,
  partnerIncomeForm,
  t,
  userIncomeForm,
  tempIncomeObject,
  partner
}: CreditRequestIncomeProps) => {

  const incomeForm = partner ? partnerIncomeForm : userIncomeForm;
  return (
    <Box>
      {Object.keys(incomeForm.getTransformedValues()).map((el: any, index: number) => (
        <CreditRequestIncomeItem
          key={el}
          disabled={disabled}
          form={form}
          options={options}
          index={index}
          t={t}
          userIncomeForm={incomeForm}
          partner={partner}
          tempIncomeObject={tempIncomeObject}
        />
      ))}
    </Box>
  )
}

export default CreditRequestIncome;